import { gql } from '@src/lib/gql'

/**
 * W4 plan downgrade (startups3 `SubscriptionScheduledChange`). The returned subscription carries
 * the pending fields so the Apollo cache updates every banner reading them.
 */
const PLAN_CHANGE_SUBSCRIPTION_FIELDS = `
  id
  subscriptionId
  productId
  state
  nextAssessmentAt
  hasPendingChange
  pendingProductId
  pendingTermId
  pendingChangeAt
  pendingProduct {
    id
    productId
    name
  }
`

/** Owner or `isAdmin`. Schedules a move to a lower plan for the end of the current term. */
export const SCHEDULE_SUBSCRIPTION_DOWNGRADE = gql`
  mutation ScheduleSubscriptionDowngrade($input: ScheduleSubscriptionDowngradeInput!) {
    scheduleSubscriptionDowngrade(input: $input) {
      subscription {
        ${PLAN_CHANGE_SUBSCRIPTION_FIELDS}
      }
    }
  }
`

/** Owner or `isAdmin`. "Keep Team": removes the scheduled change. */
export const CANCEL_SCHEDULED_SUBSCRIPTION_CHANGE = gql`
  mutation CancelScheduledSubscriptionChange($input: CancelScheduledSubscriptionChangeInput!) {
    cancelScheduledSubscriptionChange(input: $input) {
      subscription {
        ${PLAN_CHANGE_SUBSCRIPTION_FIELDS}
      }
    }
  }
`

/** `isAdmin` only. Applies a move down now: no proration, no refund, reason required and logged. */
export const ADMIN_APPLY_SUBSCRIPTION_CHANGE_NOW = gql`
  mutation AdminApplySubscriptionChangeNow($input: AdminApplySubscriptionChangeNowInput!) {
    adminApplySubscriptionChangeNow(input: $input) {
      subscription {
        ${PLAN_CHANGE_SUBSCRIPTION_FIELDS}
        product {
          id
          productId
          name
          termId
        }
      }
    }
  }
`
